/**
 * Wer StaySuite anbietet — an einer Stelle.
 *
 * Diese Angaben standen bis Vorgang 010 in `LegalView.tsx` und wurden dort
 * dreimal als `mailto:` verwendet. Seit der Grenze über 15 Einheiten braucht sie
 * eine zweite Stelle: das Blatt, das einem großen Betrieb sagt, dass es für ihn
 * ein individuelles Angebot gibt, muss ihm auch sagen, wohin er schreiben kann.
 *
 * Eine zweite abgeschriebene Adresse wäre genau der Fehler, den dieser Vorgang
 * an anderer Stelle gerade abgeschafft hat: zwei Orte für eine Angabe laufen
 * auseinander, und zwar still. Beim Impressum ist das kein Schönheitsfehler,
 * sondern eine Pflichtangabe nach § 5 ECG.
 *
 * `mail` ist die Adresse, hinter der ein Mensch sitzt. Sie wird GENANNT, aber
 * mit keiner Frist verbunden — eine Zusage ohne benannten Abnehmer wäre
 * schlimmer als Schweigen.
 *
 * `support@`, nicht `office@`: office@auviso.com EXISTIERT NICHT (René,
 * 19.08.2026, wiederholt gemeldet). support@auviso.com ist das echte Postfach —
 * derselbe Absender, über den alle Auth-Mails gehen (auth-mail via Graph).
 */
export const ANBIETER = {
  name: 'AUVISO GmbH',
  street: 'Kesselweg 4',
  city: '6167 Neustift im Stubaital',
  country: 'Österreich',
  uid: 'ATU74688803',
  fn: 'FN 516504 s, Landesgericht Innsbruck',
  web: 'www.auviso.com',
  mail: 'support@auviso.com',
} as const
